import { Component, OnInit } from '@angular/core';
import { environment } from './../../../environments/environment';
import { ApplicationStore } from '../../shared/state/store/index';
import { Store } from '@ngrx/store';
import { loadingAction } from '../../shared/state/actions/loading.action';

@Component({
	selector: 'app-not-authorized',
	templateUrl: './not-authorized.component.html',
	styleUrls: ['./not-authorized.component.scss']
})
export class NotAuthorizedComponent implements OnInit{
	constructor(private store: Store<ApplicationStore>){}

	ngOnInit(): void {
		this.store.dispatch(loadingAction({ loading: true }));
		window.location.href = `${environment.adminUrl}/auth/logout`;
	}
}
